<template>

<div id="banUserModal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div v-if="user" class="modal-content">
      <div class="modal-header">
        <h5 v-if="!user.banned" class="modal-title text-danger">{{ $t("user.ban.title") }}</h5>
        <h5 v-if="user.banned" class="modal-title">{{ $t("user.unban.title") }}</h5>
        <button type="button" class="btn-close" @click="cancel()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>{{ $t("user.ban.absolutely_sure") }}</p>
        <p v-if="!user.banned" v-html="$t('user.ban.action', {firstName: user.firstName, lastName: user.lastName})"></p>
        <p v-if="user.banned" v-html="$t('user.unban.action', {firstName: user.firstName, lastName: user.lastName})"></p>

        <div v-if="error" class="alert alert-danger" role="alert">
          {{error}}
        </div>        
      </div>
      <div class="modal-footer text-center">
        <button v-if="!user.banned" type="button" class="btn btn-danger" @click="banUser()">{{ $t("user.ban.understand_consequences_label") }}</button>
        <button v-if="user.banned" type="button" class="btn btn-danger" @click="unbanUser()">{{ $t("user.unban.understand_consequences_label") }}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{ $t("user.ban.cancel_label") }}</button>
      </div>
    </div>
  </div>
</div>

</template>

<script>

import {Modal} from 'bootstrap';
import $ from 'jquery'

import userService from '@/services/userService';
import eventConfig from '@/configs/eventConfig';

export default {
  name: 'UserBanComponent',
  props: {
    userToBan: Object
  },
  watch: 
  { 
    userToBan: function() {
      if(this.userToBan)
      {
        this.user = JSON.parse(JSON.stringify(this.userToBan));
        this.openModal();
      }
    }
  },
  data: function () {
    return {
      user: null,
      error: null,
      banModal: null
    }
  },
  components: {
    
  },
  mounted () {
    this.banModal = new Modal($('#banUserModal'));
    
    this.eventDispatcher.on(eventConfig.UNAUTHORIZED, () => {
      this.cancel();
    });

  },
  methods: {
    cancel()
    {
      this.banModal.hide();
      this.$emit(eventConfig.CANCELED);
    },
    openModal()
    {
      this.error = null;
      this.banModal.show();
    },
    banUser()
    {
      
        userService.ban(this.user).then(
          response => {
            this.banModal.hide();
            this.$emit(eventConfig.BANNED);
          },
          errors => {
            this.parseErrors(errors.response.data);
          }
        );
      
    },
    unbanUser()
    {
      
        userService.unban(this.user).then(
          response => {
            this.banModal.hide();
            this.$emit(eventConfig.BANNED);
          },
          errors => {
            this.parseErrors(errors.response.data);
          }
        );
      
    },
    parseErrors(data)
    {
      
        this.error = (data.msg_code) ? this.$t(data.msg_code) : data.msg;
      
    }
  }
}
</script>